import React from 'react';
import {withSnackbar} from "notistack";
import { Link } from "react-router-dom";
import {
    forceLogout,
    getAccessToken,
    getSchoolId,
    getSchoolYear,
    setSchoolAbbreviationName,
    setSchoolId,
    setSchoolYear,
    setSchoolYearName
} from "../../utils/authority";
import {isBrowser} from 'react-device-detect';
import UserController from "../../services/system/user/user-controller";
import {isSystemScope} from "../../utils/common";
import {toast} from "react-toastify";
import AdSchoolInfoManager from "../../services/system/school-info/ad-school-info-manager";
import YearController from "../../services/data-declaration/year-controller";
import lang from '../lang';
import QuickAccessDropdown from './QuickAccessDropdown';
import './styles.css';

const LANGUAGES = [
    { code: 'vi', name: 'Tiếng Việt', flag: '/images/vn.png' },
    { code: 'en', name: 'English', flag: '/images/us.png' },
    { code: 'kr', name: '한국어', flag: '/images/kr.png' }
];

const HEADER_CACHE_TTL = 5 * 60 * 1000;

const getHeaderCacheKey = () => {
    const token = getAccessToken() || 'anonymous';
    return `sas_header_cache_${token.slice(-12)}`;
};

const readHeaderCache = () => {
    try {
        const cached = JSON.parse(sessionStorage.getItem(getHeaderCacheKey()));
        if (cached && Date.now() - cached.cachedAt < HEADER_CACHE_TTL) return cached;
    } catch (error) {
        // Cache lỗi không được phép chặn Header; API sẽ tải lại dữ liệu.
    }
    return null;
};

const writeHeaderCache = (data) => {
    try {
        const current = readHeaderCache() || {};
        sessionStorage.setItem(getHeaderCacheKey(), JSON.stringify({
            ...current,
            ...data,
            cachedAt: Date.now()
        }));
    } catch (error) {
        // sessionStorage có thể bị chặn; Header vẫn hoạt động bằng API như cũ.
    }
};

class HeaderAfterLogin extends React.Component {
    static defaultProps = {
        account: {},
        isUploadDone: false,
        avatarInfo: {},
        isFetching: false,
    }

    constructor(props) {
        super(props);
        this.state = {
            avatar: null,
            userFullName: '',
            schoolName: '',
            currentLang: localStorage.getItem('sas_school_language') || 'vi',
            showLangDropdown: false,
            showUserDropdown: false,
            ListYear: [],
            yearId: getSchoolYear() || "-1",
            // Admin tổng: header không có ngữ cảnh trường/năm học để hiển thị.
            systemScope: isSystemScope()
        }
    }

    componentDidMount() {
        const cached = readHeaderCache();
        if (cached && cached.profile) {
            this.setState(cached.profile);
        } else {
            this.getProfile();
        }
        // Admin tổng KHÔNG ghim trường: getListSchool() lấy content[0] của danh sách sắp theo
        // created_at desc, tức là một trường bất kỳ — rồi applySchool() còn ghi cookie
        // sas_school_id bằng trường đó, khiến các màn khác âm thầm lọc theo nhầm trường.
        // Năm học cũng vậy: admin tổng không có năm học phiên (xem Layout.js).
        if (this.state.systemScope) {
            this.setState({schoolName: 'Toàn hệ thống'});
        } else {
            this.loadYears();
            if (cached && cached.school) {
                this.applySchool(cached.school);
            } else {
                this.getListSchool();
            }
        }
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (!event.target.closest('.language-dropdown') && !event.target.closest('.user-dropdown')) {
            this.setState({
                showLangDropdown: false,
                showUserDropdown: false
            });
        }
    }

    onChangeLang = (langCode) => {
        localStorage.setItem('sas_school_language', langCode);
        this.setState({ showLangDropdown: false });
        window.location.reload();
    }

    getProfile() {
        UserController.detailSelf(res => {
            if (res.success && res.data) {
                const profile = {
                    userFullName: res.data.fullName || '',
                    avatar: res.data.avatar || null
                };
                this.setState(profile);
                writeHeaderCache({ profile });
            } else {
                toast.error("Đã có lỗi xảy ra trong quá trình lấy dữ liệu, vui lòng tải lại trang!");
            }
        });
    }

    getListSchool = () => {
        let payload = {
            pageNumber: 0,
            pageSize: 10,
            sort: "created_at desc"
        };
        AdSchoolInfoManager.getListSchool(payload, res => {
            if (res.success && res.data && res.data.content && res.data.content.length > 0) {
                const school = res.data.content[0];
                this.applySchool(school);
                writeHeaderCache({ school });
            }
        });
    }

    // Chọn năm học — ngữ cảnh toàn cục, chọn 1 lần (chuyển từ PageMenu/PageHeader lên header).
    loadYears = () => {
        let cached = null;
        try {
            cached = JSON.parse(localStorage.getItem("ListYear"));
        } catch (error) {
            // Cache hỏng thì tải lại từ API.
        }
        if (cached && cached.length > 0) {
            this.setState({ListYear: cached});
            return;
        }
        YearController.getListYear({pageNumber: 0, pageSize: 1000, sort: "created_at desc"}, res => {
            if (res.success && res.data && res.data.content) {
                localStorage.setItem("ListYear", JSON.stringify(res.data.content));
                this.setState({ListYear: res.data.content});
            }
        });
    }

    onChangeYear = (e) => {
        setSchoolYear(e.target.value);
        setSchoolYearName(e.target.options[e.target.selectedIndex].text);
        window.location.reload();
    }

    applySchool = (school) => {
        if (getSchoolId() === undefined) {
            setSchoolId(school.id);
            setSchoolAbbreviationName(school.abbreviationName);
        }
        this.setState({
            schoolId: school.id,
            schoolName: school.name || '',
        });
    }

    toggleLangDropdown = (e) => {
        e.stopPropagation();
        this.setState(prev => ({
            showLangDropdown: !prev.showLangDropdown,
            showUserDropdown: false
        }));
    }

    toggleUserDropdown = (e) => {
        e.stopPropagation();
        this.setState(prev => ({
            showUserDropdown: !prev.showUserDropdown,
            showLangDropdown: false
        }));
    }

    getCurrentLangInfo = () => {
        return LANGUAGES.find(lang => lang.code === this.state.currentLang) || LANGUAGES[0];
    }

    getInitials = (name) => {
        if (!name) return 'U';
        const words = name.trim().split(' ');
        if (words.length >= 2) {
            return (words[0][0] + words[words.length - 1][0]).toUpperCase();
        }
        return name.substring(0, 2).toUpperCase();
    }

    render() {
        const { userFullName, schoolName, showLangDropdown, showUserDropdown, currentLang } = this.state;
        const currentLangInfo = this.getCurrentLangInfo();

        return (
            <div className="header-wrapper">
                <div className="header-container">
                    {/* Logo Section */}
                    <div className="header-logo-section">
                        <Link to="/ad-sas-school" className="header-logo">
                            <img src="/images/logo_sas.png" alt="Logo" />
                            <div className="header-info">
                                <h1 className="header-system-name">SAS CMS</h1>
                                <p className="header-school-name" title={schoolName}>{schoolName}</p>
                            </div>
                        </Link>
                    </div>

                    <div className="header-right">
                    {/* Năm học — ngữ cảnh toàn cục, hiện cả trên mobile.
                        Ẩn với admin tổng: năm học là tham số của từng báo cáo, không phải
                        ngữ cảnh phiên (ba-shared/api-contracts/system-report/README.md). */}
                    {!this.state.systemScope && (
                    <div className="header-year" title="Năm học">
                        <i className="fas fa-calendar-alt"/>
                        <select value={this.state.yearId} onChange={this.onChangeYear}>
                            <option value="-1">Tất cả</option>
                            {this.state.ListYear?.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.summer ? "Kỳ hè-" : ""}{item.year}-{parseInt(item.year) + 1}
                                </option>
                            ))}
                        </select>
                    </div>
                    )}

                    {/* Header Actions */}
                    {isBrowser && (
                        <div className="header-actions">
                            {/* Quick Access ("Xem nhanh") */}
                            <QuickAccessDropdown />

                            {/* Language Dropdown */}
                            <div className={`language-dropdown ${showLangDropdown ? 'open' : ''}`}>
                                <button
                                    className="language-btn"
                                    onClick={this.toggleLangDropdown}
                                    type="button"
                                >
                                    <img src={currentLangInfo.flag} alt={currentLangInfo.name} />
                                    <span>{currentLangInfo.name}</span>
                                    <i className="fas fa-chevron-down"></i>
                                </button>
                                <div className="language-menu">
                                    {LANGUAGES.map((language) => (
                                        <div
                                            key={language.code}
                                            className={`language-item ${currentLang === language.code ? 'active' : ''}`}
                                            onClick={() => this.onChangeLang(language.code)}
                                        >
                                            <img src={language.flag} alt={language.name} />
                                            <span>{language.name}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* User Dropdown */}
                            <div className={`user-dropdown ${showUserDropdown ? 'open' : ''}`}>
                                <button
                                    className="user-btn"
                                    onClick={this.toggleUserDropdown}
                                    type="button"
                                >
                                    <div className="user-avatar">
                                        {this.state.avatar ? (
                                            <img
                                                src={this.state.avatar}
                                                alt={userFullName}
                                                onError={(e) => { e.target.style.display = 'none'; }}
                                            />
                                        ) : this.getInitials(userFullName)}
                                    </div>
                                    <span className="user-name">{userFullName}</span>
                                    <i className="fas fa-chevron-down"></i>
                                </button>
                                <div className="user-menu">
                                    <div className="user-menu-header">
                                        <p className="user-fullname">{userFullName}</p>
                                        <p className="user-role">{schoolName}</p>
                                    </div>
                                    <Link
                                        to="/ad-sas-school/quan-ly-thong-tin-ca-nhan"
                                        className="user-menu-item"
                                        onClick={() => this.setState({ showUserDropdown: false })}
                                    >
                                        <i className="fas fa-user"></i>
                                        <span>{lang.header?.profile || 'Thông tin cá nhân'}</span>
                                    </Link>
                                    <div
                                        className="user-menu-item logout"
                                        onClick={forceLogout}
                                    >
                                        <i className="fas fa-sign-out-alt"></i>
                                        <span>{lang.header?.logout || 'Đăng xuất'}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Mobile Menu Button */}
                    <button
                        className="mobile-menu-btn"
                        type="button"
                        onClick={() => this.props.toggleSidebarMobile()}
                    >
                        <i className="fas fa-bars"></i>
                    </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withSnackbar(HeaderAfterLogin);
